<div class="main-content-wrapper add-test-schedule-container">
    <div class="content-wrapper">
        <ng-template #newscheduletemp></ng-template>
    </div>
</div>